import { AxiosResponse } from 'axios'
import { axiosApi, axiosBase } from '@/axios'
import { TokensInterface, LoginInterface, User } from './auth.interface'
import { Body } from '@/utils/interfaces'

export const LoginRoute = '/api/auth/obtain-token/'

export const login = (
  body: LoginInterface,
): Promise<AxiosResponse<TokensInterface>> => {
  return axiosBase.post(LoginRoute, body)
}

export const refreshTokens = (): Promise<AxiosResponse<TokensInterface>> => {
  return axiosBase.post('/api/auth/refresh-token/')
}

export const changePassword = (body: Body): Promise<AxiosResponse> =>
  axiosApi.post('/user/password/change/', body)

export const getProfile = (): Promise<AxiosResponse<User>> =>
  axiosApi.get('/user/')

export const logout = (): Promise<AxiosResponse<{ refresh: string }>> =>
  axiosApi.post('/user/logout/')

export const generateQR = (): Promise<AxiosResponse<{ code: string }>> =>
  axiosApi.get('/auth/totp/create/')

export const checkCode = (
  otp_token: string | number,
): Promise<AxiosResponse<{ access: string }>> =>
  axiosApi.post('/auth/totp/verify/', {
    otp_token,
  })
